import axios from "axios";


export const Step1Varification = async (mobile, token) => {

    const body = {

        mobile: mobile,
        token: token
    }


    try {

        const res = await axios.post("https://panel.hamkadeh.com/api/v2/user/send-verification", body);
        return [res.data.status, res.data.message];

    } catch (error) {

        console.log(error);
    }

}


export const Step2Varification = async (mobile, token , code) => {

    const body = {

        mobile: mobile,
        token: token,
        code : code
    }

    try {

        const res = await axios.post("https://panel.hamkadeh.com/api/v2/user/mobile-verification", body);
        return res.data.status ;

    } catch (error) {
        
        console.log(error);
    }

}